/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DateCache, dateCache, Role } from '@touchplan/common';
import { PromisePin } from '@touchplan/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { TicketPromiseIconComponent } from 'src/app/components/ticket/ticket-promise-icon/ticket-promise-icon.component';
import { TicketThumbnailComponent } from 'src/app/components/ticket/ticket-thumbnail/ticket-thumbnail.component';

@Component({
	selector: 'ticket-list-item',
	standalone: true,
	imports: [CommonModule, MaterialModule, TicketThumbnailComponent, TicketPromiseIconComponent],
	templateUrl: './ticket-list-item.component.html',
	styleUrls: ['./ticket-list-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketListItemComponent implements OnInit {
	@Input() public liveDurationDays?: number;
	@Input() public liveCrewSize?: number;
	@Input() public actualFinish: string;
	@Input() public actualStart: string;
	@Input() public liveRole: Role;
	@Input() public ticketType: string;
	@Input() public activityName: string;
	@Input() public selectedType: string;
	@Input() public locationName: string;
	@Input() public liveStart: string;
	@Input() public liveFinish: string;
	@Input() public livePromisePeriodStack?: PromisePin[];
	@Input() public selected: boolean = false;
	@Input() public cycleSelected: boolean = false;

	public dateCache: DateCache = dateCache;

	constructor() {}

	public ngOnInit(): void {}
}
